import { render, staticRenderFns } from "./ele-left-top.vue?vue&type=template&id=604805aa&scoped=true"
import script from "./ele-left-top.vue?vue&type=script&lang=js"
export * from "./ele-left-top.vue?vue&type=script&lang=js"
import style0 from "./ele-left-top.vue?vue&type=style&index=0&id=604805aa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604805aa",
  null
  
)

export default component.exports